SyncInterceptor.$inject = ["Sync"];configureSyncInterceptors.$inject = ["$httpProvider"];SyncFactory.$inject = ["$rootScope", "firebase", "$firebaseObject", "$firebaseAuth", "$timeout", "$injector", "ApiFirebase"]; /**
                                                                                                                                                                                                                        * @namespace Sync
                                                                                                                                                                                                                        * @returns {Factory}
                                                                                                                                                                                                                        */
export function SyncFactory($rootScope, firebase, $firebaseObject, $firebaseAuth, $timeout, $injector, ApiFirebase) {
  "ngInject";
  var _appVersionFirebase;
  var _localVersion;
  var _user;
  var _initialized;

  var _onVersionChangeCallbacks = [];

  _initialize();

  /**
                  * @name Sync
                  * @desc The Factory to be returned
                  */
  var Sync = {
    incrementAppVersion: incrementAppVersion,
    onVersionChanged: onVersionChanged,
    _initialize: _initialize,
    get initialized() {
      return _initialized;
    } };


  return Sync;

  function _initialize() {
    // TODO: auth firebase
    // https://firebase.google.com/docs/auth/web/custom-auth
    // https://firebase.google.com/docs/auth/admin/create-custom-tokens
    var auth = $firebaseAuth();
    $timeout(function () {
      var UserService = $injector.get('UserService');
      var onUserChange = function onUserChange(user) {
        if (user && user.firebase_token && user.uid) {
          auth.$signInWithCustomToken(user.firebase_token).then(firebaseAuthSuccess, firebaseAuthError);
        }
      };
      onUserChange(UserService.data);
      $rootScope.$watch(function () {
        return UserService.data;
      }, onUserChange);
    }, 1);

    function firebaseAuthSuccess(authData) {
      console.log('firebase auth success');
      ApiFirebase.getAppVersion(authData['uid']).
      then(function (res) {
        _appVersionFirebase = res;
        _localVersion = _appVersionFirebase.$value;
        _appVersionFirebase.$watch(function () {
          // this means the change came from some other source -> app reload!
          if (!_appVersionFirebase.$value) {
            ApiFirebase.setAppVersion(authData['uid'], 1);
            return;
          }

          var newVal = parseInt(_appVersionFirebase.$value);
          if (_localVersion < newVal) {
            _fireOnVersionChangeCallbacks(newVal);
            _localVersion = newVal;
          }

          // console.log("app version: ", newVal);
        });
        _initialized = true;
      });
    }

    function firebaseAuthError(err) {
      console.error('firebase auth error: ', err);
    }
  }

  function _fireOnVersionChangeCallbacks(ver) {
    _onVersionChangeCallbacks.forEach(function (cb) {
      if (angular.isFunction(cb)) {
        cb(ver);
      }
    });
  }

  function incrementAppVersion() {
    if (_initialized) {
      var ver = parseInt(_appVersionFirebase.$value) || 0;
      ver += 1;
      _localVersion = ver;
      _appVersionFirebase.$value = ver;
      _appVersionFirebase.$save();
      return _appVersionFirebase.$value;
    }

    return -1;
  }

  function onVersionChanged(callback) {
    // call when external change has happened
    var idx = _onVersionChangeCallbacks.push(callback) - 1;

    // return unsubscribe function
    var unsub = function unsub() {
      delete _onVersionChangeCallbacks[idx];
    };
    return unsub;
  }
}

export function configureSyncInterceptors($httpProvider) {
  "ngInject";
  $httpProvider.interceptors.push(SyncInterceptor);
}

function SyncInterceptor(Sync) {
  "ngInject";
  return {
    request: function request(config) {
      // skip in swap
      // if (angular.isString(config.url) && config.url.indexOf('usermealitems') > -1 && config.method === 'PUT') return config;
      // we update data version if app successfully changes something via PUT/POST/DELET request
      if (config.method === 'PUT' || config.method === 'POST' || config.method === 'DELETE') {
        Sync.incrementAppVersion();
      }
      return config;
    } };

}